import React, { useEffect } from 'react';
import { BooleanInput } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import useCheckAccess from 'hooks/useCheckAccess';

type RequiredInputProps = {
  action: 'create' | 'update';
  getSource?: (source: string) => string;
};

const RequiredInput = (props: RequiredInputProps) => {
  const { action, getSource } = props;
  const { setValue } = useFormContext();
  const requiredSource = getSource?.('required') ?? 'required';
  const requiredForApprovalSource = getSource?.('required_for_approval') ?? 'required_for_approval';
  const requiredFieldValue = useWatch({ name: requiredSource });

  useEffect(() => {
    if (requiredFieldValue) {
      setValue(requiredForApprovalSource, true);
    }
  }, [requiredFieldValue, requiredForApprovalSource, setValue]);

  const checkAccess = useCheckAccess();
  return (
    <>
      {checkAccess(action, 'QualificationAttribute', 'required') && (
        <BooleanInput source={requiredSource} />
      )}
      {checkAccess(action, 'QualificationAttribute', 'required_for_approval') && (
        <BooleanInput source={requiredForApprovalSource} disabled={requiredFieldValue} />
      )}
    </>
  );
};

export default RequiredInput;
